import { createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "en-drawer-panel" };
const _hoisted_2 = { class: "en-left-panel" };
const _hoisted_3 = ["data-active"];
const _hoisted_4 = { class: "mb-5" };
const _hoisted_5 = ["data-active"];
const _hoisted_6 = { class: "truncate" };
const _hoisted_7 = {
    class: "account-item",
    "data-guided-tour-step": "step-profile"
};
const _hoisted_8 = {
    key: 0,
    class: "flex w-full items-center justify-center gap-2 overflow-hidden rounded-md p-2 text-sm h-8.75 text-en-blue-500 hover:bg-en-blue-100 cursor-pointer"
};
const _hoisted_9 = {
    key: 1,
    class: "flex w-full items-center gap-2 overflow-hidden rounded-md p-2 text-left text-sm h-8.75 text-en-blue-500 hover:bg-en-blue-100 cursor-pointer min-w-0"
};
const _hoisted_10 = ["title"];
const _hoisted_11 = { class: "text-[10px] font-semibold text-en-blue-300 px-1 py-0.5 mb-1 uppercase tracking-wide" };
const _hoisted_12 = ["href"];
const _hoisted_13 = ["href"];
const _hoisted_14 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ($props.isLoggedIn && $setup.loaded)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["en-drawer-outer", { 'is-rail': $setup.rail }])
        }, [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createCommentVNode(" Branding "),
                    _createElementVNode("div", {
                        class: _normalizeClass(["en-account-settings", { expanded: !$setup.rail }])
                    }, [
                        _createElementVNode("div", {
                            class: "branding-click-target",
                            "aria-label": "Home",
                            onClick: _cache[0] || (_cache[0] = ($event) => ($setup.tryNavigateTo($setup.engineUrl)))
                        }, [
                            _createVNode($setup["EnIcon"], {
                                class: "icon-32 icon-enloc_logo_min en-logo-icon",
                                "aria-hidden": "true"
                            }),
                            _cache[11] || (_cache[11] = _createElementVNode("span", null, "EN.Gine", -1 /* CACHED */))
                        ])
                    ], 2 /* CLASS */),
                    _createElementVNode("div", {
                        class: _normalizeClass(["en-menu", { collapsed: $setup.rail }])
                    }, [
                        _createCommentVNode(" Dashboard item — rail mode "),
                        ($setup.rail)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["group-icon-wrapper", { active: $setup.isDashboardActive }])
                            }, [
                                _createVNode($setup["EnTooltip"], {
                                    text: $setup.t('common.dashboard.title'),
                                    position: "right",
                                    "content-class": "z-[9999]"
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("button", {
                                            class: "flex w-full items-center justify-center gap-2 overflow-hidden rounded-md p-2 text-sm h-8.75 text-en-blue-500 hover:bg-en-blue-100 border-none bg-transparent cursor-pointer transition-[width,height,padding] data-[active=true]:text-en-red-400 data-[active=true]:hover:bg-en-red-100",
                                            "data-active": $setup.isDashboardActive,
                                            "data-guided-tour-step": "step-navbar",
                                            onClick: _cache[1] || (_cache[1] = ($event) => ($setup.tryNavigateTo($setup.engineUrl)))
                                        }, [
                                            _createVNode($setup["EnDashboardIconWrapper"], {
                                                class: "module-icon shrink-0",
                                                active: $setup.isDashboardActive,
                                                icon: $setup.NavigationIcons.DASHBOARD,
                                                variant: $setup.EnDashboardIconVariants.Navigation
                                            }, null, 8 /* PROPS */, ["active", "icon", "variant"])
                                        ], 8 /* PROPS */, _hoisted_3)
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["text"])
                            ], 2 /* CLASS */))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createCommentVNode(" Dashboard item — expanded mode "),
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("button", {
                                        class: "flex w-full items-center gap-2 overflow-hidden rounded-md p-2 text-left text-sm h-8.75 text-en-blue-500 hover:bg-en-blue-100 border-none bg-transparent cursor-pointer transition-[width,height,padding] data-[active=true]:text-en-red-400 data-[active=true]:hover:bg-en-red-100",
                                        "data-active": $setup.isDashboardActive,
                                        "data-guided-tour-step": "step-navbar",
                                        onClick: _cache[2] || (_cache[2] = ($event) => ($setup.tryNavigateTo($setup.engineUrl)))
                                    }, [
                                        _createVNode($setup["EnDashboardIconWrapper"], {
                                            class: "module-icon shrink-0",
                                            active: $setup.isDashboardActive,
                                            icon: $setup.NavigationIcons.DASHBOARD,
                                            variant: $setup.EnDashboardIconVariants.Navigation
                                        }, null, 8 /* PROPS */, ["active", "icon", "variant"]),
                                        _createElementVNode("span", _hoisted_6, _toDisplayString($setup.t('common.dashboard.title')), 1 /* TEXT */)
                                    ], 8 /* PROPS */, _hoisted_5)
                                ])
                            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
                        _createVNode($setup["EnNavigationArea"], {
                            rail: $setup.rail ?? false,
                            "current-enpower-account": $setup.internalCurrentAccount,
                            "build-url": $setup.buildUrl
                        }, {
                            "group-extra": _withCtx((slotProps) => [
                                (!$setup.rail && $setup.matchesPowerSwitcherGroup(slotProps.group))
                                    ? (_openBlock(), _createBlock($setup["EnPowerAccountSwitch"], {
                                        key: 0,
                                        modelValue: $setup.internalCurrentAccount,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (($setup.internalCurrentAccount) = $event)),
                                        "has-en-power-account": $setup.internalHasAccount,
                                        "onUpdate:hasEnPowerAccount": _cache[4] || (_cache[4] = ($event) => (($setup.internalHasAccount) = $event)),
                                        "en-power-accounts": $setup.allEnPowerAccounts,
                                        "is-expanded": "",
                                        onUpdateEnPowerId: $setup.reloadPage
                                    }, null, 8 /* PROPS */, ["modelValue", "has-en-power-account", "en-power-accounts", "onUpdateEnPowerId"]))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["rail", "current-enpower-account", "build-url"])
                    ], 2 /* CLASS */),
                    _createElementVNode("div", {
                        class: _normalizeClass(["account-section", { collapsed: $setup.rail }])
                    }, [
                        _createVNode($setup["DropdownMenuRoot"], {
                            open: $setup.accountMenuOpen,
                            "onUpdate:open": _cache[6] || (_cache[6] = ($event) => (($setup.accountMenuOpen) = $event)),
                            modal: false
                        }, {
                            default: _withCtx(() => [
                                _createVNode($setup["DropdownMenuTrigger"], { "as-child": "" }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_7, [
                                            ($setup.rail)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                                    _createVNode($setup["EnTooltip"], {
                                                        text: $setup.userDisplayName,
                                                        position: "right",
                                                        "content-class": "z-[9999]"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode($setup["EnDashboardIconWrapper"], {
                                                                class: "module-icon shrink-0",
                                                                icon: $setup.NavigationIcons.ACCOUNTS,
                                                                variant: $setup.EnDashboardIconVariants.Navigation
                                                            }, null, 8 /* PROPS */, ["icon", "variant"])
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }, 8 /* PROPS */, ["text"])
                                                ]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                    _createVNode($setup["EnDashboardIconWrapper"], {
                                                        class: "module-icon shrink-0",
                                                        icon: $setup.NavigationIcons.ACCOUNTS,
                                                        variant: $setup.EnDashboardIconVariants.Navigation
                                                    }, null, 8 /* PROPS */, ["icon", "variant"]),
                                                    _createElementVNode("span", {
                                                        class: "flex-1 truncate",
                                                        title: $setup.userDisplayName
                                                    }, _toDisplayString($setup.userDisplayName), 9 /* TEXT, PROPS */, _hoisted_10)
                                                ]))
                                        ])
                                    ]),
                                    _: 1 /* STABLE */
                                }),
                                _createVNode($setup["DropdownMenuPortal"], null, {
                                    default: _withCtx(() => [
                                        _createVNode($setup["DropdownMenuContent"], {
                                            side: "right",
                                            "side-offset": $setup.rail ? 6 : 0,
                                            "body-lock": false,
                                            "collision-padding": 8,
                                            class: "z-2500 min-w-50 rounded-lg border border-en-blue-200 bg-white p-2 shadow-[0_6px_15.3px_0_rgba(13,48,72,0.09)] origin-[--reka-dropdown-menu-content-transform-origin] data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=right]:slide-in-from-left-1 data-[side=left]:slide-in-from-right-1 data-[side=bottom]:slide-in-from-top-1 data-[side=top]:slide-in-from-bottom-1 transition-colors duration-150"
                                        }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_11, _toDisplayString($setup.t('common.dashboard.accountSection')), 1 /* TEXT */),
                                                _createElementVNode("a", {
                                                    class: "block w-full px-2 py-1.5 text-sm rounded-md no-underline text-en-blue-500 hover:bg-en-blue-100 cursor-pointer",
                                                    href: $setup.userProfileUrl,
                                                    onClick: _cache[5] || (_cache[5] = ($event) => ($setup.accountMenuOpen = false))
                                                }, _toDisplayString($setup.t('common.dashboard.accountSettings')), 9 /* TEXT, PROPS */, _hoisted_12),
                                                ($props.showUserImitationMenuItem)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 0,
                                                        onClick: $setup.onImitateUserClick,
                                                        class: "block w-full text-left px-2 py-1.5 text-sm rounded-md bg-transparent border-none text-en-blue-500 hover:bg-en-blue-100 cursor-pointer"
                                                    }, _toDisplayString($setup.t('common.dashboard.imitateUser')), 1 /* TEXT */))
                                                    : _createCommentVNode("v-if", true),
                                                ($setup.rail)
                                                    ? (_openBlock(), _createElementBlock("a", {
                                                        key: 1,
                                                        href: $setup.logoutUrl,
                                                        class: "block px-2 py-1.5 text-sm rounded-md no-underline text-en-blue-500 hover:bg-en-blue-100 cursor-pointer"
                                                    }, _toDisplayString($setup.t('common.dashboard.signOut')), 9 /* TEXT, PROPS */, _hoisted_13))
                                                    : _createCommentVNode("v-if", true),
                                                ($setup.isDevelopment)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 2,
                                                        onClick: $setup.toggleProdView,
                                                        class: "block w-full text-left px-2 py-1.5 text-sm rounded-md bg-transparent border-none text-en-blue-500 hover:bg-en-blue-100 cursor-pointer"
                                                    }, _toDisplayString($props.isProdViewEnabled ? 'Disable Prod View' : 'Enable Prod View'), 1 /* TEXT */))
                                                    : _createCommentVNode("v-if", true)
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["side-offset"])
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["open"]),
                        (!$setup.rail)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: $setup.logoutUrl,
                                class: "en-nav-list-item top-level-item logout-list-item"
                            }, [
                                _createVNode($setup["EnDashboardIconWrapper"], {
                                    class: "module-icon",
                                    variant: $setup.EnDashboardIconVariants.Navigation,
                                    icon: $setup.NavigationIcons.LOGOUT
                                }, null, 8 /* PROPS */, ["variant", "icon"])
                            ], 8 /* PROPS */, _hoisted_14))
                            : _createCommentVNode("v-if", true)
                    ], 2 /* CLASS */)
                ]),
                _createVNode($setup["EnImitateUserDialog"], {
                    modelValue: $setup.imitateUserDialogOpen,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => (($setup.imitateUserDialogOpen) = $event))
                }, null, 8 /* PROPS */, ["modelValue"]),
                _createElementVNode("button", {
                    class: "toggle-drawer-btn",
                    onMouseover: _cache[8] || (_cache[8] = ($event) => ($setup.isDrawerTogglerHovered = true)),
                    onMouseleave: _cache[9] || (_cache[9] = ($event) => ($setup.isDrawerTogglerHovered = false)),
                    onClick: _cache[10] || (_cache[10] = ($event) => ($setup.updateRail(!$setup.rail)))
                }, [
                    _createElementVNode("div", {
                        class: _normalizeClass(["line top", { expanded: $setup.rail, hover: $setup.isDrawerTogglerHovered }])
                    }, null, 2 /* CLASS */),
                    _createElementVNode("div", {
                        class: _normalizeClass(["line bottom", { expanded: $setup.rail, hover: $setup.isDrawerTogglerHovered }])
                    }, null, 2 /* CLASS */)
                ], 32 /* NEED_HYDRATION */)
            ])
        ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true);
}
